<div #myDiv class=" flex justify-start lg:sticky lg:top-[120px] no-scrollbar" [ngStyle]="{'height': dynamicHeight}">
  <div class=" w-full relative">
    <div class="w-full absolute transition-div" [ngStyle]="{'top': '-' + dynamicTop + 'px'}">
      <div class="">
        <!-- <div class=""> -->
        <div class="block lg:hidden mobile-booking-detail bg-teal" *ngIf="roomType && room && paymentSummary && ratePlan">
          <div class="flex text-white">
            <div class="text-[20px] font-NewSpirit">{{'booking.total' | translate}}</div>
            <div class="flex-1 text-right text-body font-medium">
              <div>{{getTotalMonthly() | currency: paymentSummary.currency : 'symbol-narrow'}} {{'booking.monthly' |
                translate}}</div>
              <div class="mt-2">{{formatNumber(paymentSummary.initialPaymentAmountOfFirstMonth) | currency:
                paymentSummary.currency : 'symbol-narrow'}} {{'booking.upfront' | translate}}</div>
            </div>
          </div>
          <div class="line bg-gainsboro"></div>
          <div class="mt-6">
            <button *ngIf="!atExtraPage" class="btn btn-primary w-full" (click)="submit()">{{'button.label.confirm' |
              translate}}</button>
            <button *ngIf="atExtraPage" class="btn btn-primary w-full" (click)="submit()">{{'button.label.apply-now' |
              translate}}</button>
          </div>
          <div class="text-center mt-2 text-white" *ngIf="!atExtraPage">
            Car parking and additional storage can be requested at the next step
          </div>
        </div>
        <div class="summary-box block px-[12px] py-[12px] lg:p-6 bg-teal rounded shadow-md lg:ml-6 text-white"
          [ngClass]="paymentSummary ? 'block' : 'hidden lg:block'">
          <div class="text-white text-[32px] font-NewSpirit" *ngIf="!room">{{'booking.booking-detail-summary' | translate}}
          </div>
          <div class="text-white text-[20px] lg:text-[32px] font-NewSpirit" *ngIf="room">Apt {{room.roomNumber}}</div>
          <div *ngIf="room" class="mt-3 lg:mt-0 text-[12px] lg:text-[14px] text-gainsboro"><span
              *ngIf="room.sectionDescription">{{room.sectionDescription}}</span></div>
          <div class="line"></div>
      
          <div>
            <div class="summary-field mb-6 lg:mb-4" *ngIf="paymentSummary">
              <div class="overflow-hidden">
                <img *ngIf="getImage()" class="w-[66px] h-[40px] lg:w-[92px] lg:h-[56px] rounded-m" [src]="getImage()"
                  alt="" />
              </div>
              <div class="text-right">
                <div *ngIf="roomType && room && paymentSummary && ratePlan">
                  <div class="lg:text-[16px]">{{formatDate(paymentSummary.arrivalDate)}} -
                    {{formatDate(paymentSummary.departureDate)}}</div>
                  <div class="lg:text-[16px]">{{monthsBetweenDates(paymentSummary.arrivalDate, paymentSummary.departureDate)}}
                    months</div>
                </div>
              </div>
            </div>
      
      
      
            <div *ngIf="roomType && room && paymentSummary && ratePlan">
      
              <div class="summary-block-title">{{'booking.monthly-payments' | translate}}</div>
              <div class="text-[12px] mt-2 mb-4 text-gainsboro">{{'booking.figures-currency' | translate }}</div>
              <!-- monthly rate package, Monthly Room Rate -->
              <div class="field-group mt-[14px]" [class.active]="panelState.monthlyRatePackageActive">
                <div class="field-row">
                  <div class="field-label">
                    <div>{{'rent-types.month' | translate}}</div>
                  </div>
                  <div class="field-value lg:text-[18px] lg:font-semibold">
                    {{formatNumber(paymentSummary.rate.monthlyRateAmount) | money}}</div>
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer"
                      (click)="panelState.monthlyRatePackageActive = !panelState.monthlyRatePackageActive"><img
                        src="assets/images/down.svg" style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
      
                <div class="field-content">
                  <div class="field-row text-white">
                    <div class="field-label font-normal">{{roomType.roomTypeName || ''}} ({{ratePlan.ratePlanName || ''}})
                    </div>
                    <div class="field-value font-normal">{{formatNumber(paymentSummary.rate.monthlyRateAmount) | money}}</div>
                  </div>
                </div>
              </div>
      
              <!-- Utilities -->
              <div class="field-group" [class.active]="panelState.utilities" *ngIf="canShowUtilities()">
                <div class="field-row">
                  <div class="field-label">
                    <div>{{'booking.utilities' | translate}}</div>
                  </div>
                  <div class="field-value lg:text-[18px] lg:font-semibold">
                    {{formatNumber(getTotalExtra(paymentSummary.utilities)) | money}}</div>
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer" (click)="panelState.utilities = !panelState.utilities"><img
                        src="assets/images/down.svg" style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
      
                <div class="field-content">
                  <div class="field-row text-white" *ngFor="let utility of paymentSummary.utilities">
                    <div class="field-label font-normal">{{utility.extraName}} x {{utility.quantity}} <span *ngIf="getTaxDes(utility)">({{getTaxDes(utility)}})</span></div>
                    <div class="field-value font-normal">{{formatNumber(utility.monthlyRateAmount * utility.quantity) |
                      money}}</div>
                  </div>
                </div>
              </div>
      
              <!-- Addons -->
              <div class="field-group" [class.active]="panelState.monthlyAddons" *ngIf="canShowExtras()">
                <div class="field-row">
                  <div class="field-label">
                    <div>{{'booking.extras' | translate}}</div>
                  </div>
                  <div class="field-value lg:text-[18px] lg:font-semibold">
                    {{formatNumber(getTotalExtra(paymentSummary.addOns)) | money}}</div>
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer"
                      (click)="panelState.monthlyAddons = !panelState.monthlyAddons"><img src="assets/images/down.svg"
                        style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
      
                <div class="field-content">
                  <div class="field-row" *ngFor="let extra of paymentSummary.addOns">
                    <div class="field-label font-normal">{{extra.extraName}} x {{extra.quantity}} <span *ngIf="getTaxDes(extra)">({{getTaxDes(extra)}})</span></div>
                    <div class="field-value font-normal">{{formatNumber(extra.monthlyRateAmount * extra.quantity) | money}}
                    </div>
                  </div>
                </div>
              </div>
      
              <!-- total Monthly Payments -->
              <div class="field-group mt-[14px]">
                <div class="field-row ">
                  <div class="field-label uppercase text-[16px] font-medium">{{'booking.total' | translate}}</div>
                  <div class="field-value text-[16px] font-medium ">
                    {{formatNumber(getTotalMonthly()) | currency: paymentSummary.currency : 'symbol-narrow'}}</div>
                </div>
              </div>
              <div class="line"></div>
      
              <div class="summary-block-title">{{'booking.upfront-payments' | translate}}</div>
              <div class="text-[12px] mt-2 mb-4 text-gainsboro">{{'booking.payable-on-completion-booking' | translate }}</div>
              <div class="field-group" [class.active]="panelState.adminFeeActive" *ngIf="paymentSummary.adminFeeAmount">
                <div class="field-row">
                  <div class="field-label">{{'booking.admin-fees' | translate}}</div>
                  <div class="field-value">{{formatNumber(paymentSummary.adminFeeAmount) | money}}</div>
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer"
                      (click)="panelState.adminFeeActive = !panelState.adminFeeActive"><img src="assets/images/down.svg"
                        style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
                <div class="field-content">
                  <div class="field-row text-white">
                    <div class="field-label font-normal">{{'booking.admin-fees' | translate}}</div>
                    <div class="field-value font-normal">{{formatNumber(paymentSummary.adminFeeAmount) | money}}</div>
                  </div>
                </div>
              </div>
      
              <!-- deposit rent -->
              <div class="field-group" [class.active]="panelState.securityDepositActive"
                *ngIf="paymentSummary.guaranteePolicy.depositNumberMonths && paymentSummary.securityAmount">
                <div class="field-row">
                  <div class="field-label whitespace-nowrap">{{'booking.deposit' | translate}}
                    ({{paymentSummary.guaranteePolicy.depositNumberMonths}} x {{'rent-types.month' | translate}})
                    <span [pTooltip]="tooltipDeposit" tabIndex="0" tooltipPosition="bottom" [tooltipEvent]="tooltipEvent"
                      *ngIf="getDescription(paymentConfigInfo.depositToolTip)"
                      class="material-symbols-outlined text-[16px] mt-[-4px] cursor-pointer text-accent">
                      help
                    </span>
                    <ng-template #tooltipDeposit>
                      <div [innerHtml]="getDescription(paymentConfigInfo.depositToolTip)">
                      </div>
                    </ng-template>
                  </div>
                  <div class="field-value whitespace-nowrap">{{formatNumber(paymentSummary.securityAmount) | money}}</div>
      
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer"
                      (click)="panelState.securityDepositActive = !panelState.securityDepositActive"><img
                        src="assets/images/down.svg" style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
                <div class="field-content">
                  <div class="field-row text-white">
                    <div class="field-label font-normal">{{'booking.deposit' | translate}}
                      ({{paymentSummary.guaranteePolicy.depositNumberMonths}} x {{'rent-types.month' | translate}})</div>
                    <div class="field-value font-normal"></div>
                  </div>
                </div>
              </div>
      
              <div class="field-group" [class.active]="panelState.securityDepositActive"
                *ngIf="paymentSummary.guaranteePolicy.depositNumberWeeks && paymentSummary.securityAmount">
                <div class="field-row">
                  <div class="field-label whitespace-nowrap">{{'booking.deposit' | translate}}
                    ({{paymentSummary.guaranteePolicy.depositNumberWeeks}} x {{'rent-types.week' | translate}})
                    <span [pTooltip]="tooltipDeposit" tabIndex="0" tooltipPosition="bottom" [tooltipEvent]="tooltipEvent"
                      *ngIf="getDescription(paymentConfigInfo.depositToolTip)"
                      class="material-symbols-outlined text-[16px] mt-[-4px] cursor-pointer text-accent">
                      help
                    </span>
                    <ng-template #tooltipDeposit>
                      <div class="tooltip-text" [innerHtml]="getDescription(paymentConfigInfo.depositToolTip)">
                      </div>
                    </ng-template>
                  </div>
                  <div class="field-value whitespace-nowrap">{{formatNumber(paymentSummary.securityAmount) | money}}</div>
      
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer"
                      (click)="panelState.securityDepositActive = !panelState.securityDepositActive"><img
                        src="assets/images/down.svg" style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
                <div class="field-content">
                  <div class="field-row text-white">
                    <div class="field-label font-normal">{{'booking.deposit' | translate}}
                      ({{paymentSummary.guaranteePolicy.depositNumberWeeks}} x {{'rent-types.week' | translate}})</div>
                    <div class="field-value font-normal"></div>
                  </div>
                </div>
              </div>
      
              <!-- bond fee rent -->
              <div class="field-group" [class.active]="panelState.securityBondActive" *ngIf="canShowBondSection()">
                <div class="field-row">
                  <div class="field-label whitespace-nowrap">{{'booking.bond' | translate}}
                    <span
                      *ngIf="paymentSummary.guaranteePolicy.bondAmount == 0">({{paymentSummary.guaranteePolicy.bondAmountNumberMonths
                      || paymentSummary.guaranteePolicy.bondAmountNumberWeeks}} x
                      {{(paymentSummary.guaranteePolicy.bondAmountNumberMonths ? 'rent-types.month' : 'rent-types.week') |
                      translate}})</span>
                    <span [pTooltip]="tooltipBond" tabIndex="0" tooltipPosition="bottom" [tooltipEvent]="tooltipEvent"
                      *ngIf="getDescription(paymentConfigInfo.bondToolTip)"
                      class="material-symbols-outlined text-[16px] mt-[-4px] cursor-pointer text-accent">
                      help
                    </span>
                    <ng-template #tooltipBond>
                      <div [innerHtml]="getDescription(paymentConfigInfo.bondToolTip)"></div>
                    </ng-template>
                  </div>
                  <div class="field-value whitespace-nowrap">{{formatNumber(paymentSummary.bondAmount) | money}}</div>
      
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer"
                      (click)="panelState.securityBondActive = !panelState.securityBondActive"><img
                        src="assets/images/down.svg" style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
                <div class="field-content">
                  <div class="field-row text-white">
                    <div class="field-label font-normal">{{'booking.bond-flat-rate' | translate}}
                      <span
                        *ngIf="paymentSummary.guaranteePolicy.bondAmount == 0">({{paymentSummary.guaranteePolicy.bondAmountNumberMonths
                        || paymentSummary.guaranteePolicy.bondAmountNumberWeeks}} x
                        {{(paymentSummary.guaranteePolicy.bondAmountNumberMonths ? 'rent-types.month' : 'rent-types.week') |
                        translate}})</span>
                    </div>
                    <div class="field-value font-normal">{{formatNumber(paymentSummary.bondAmount) | money}}</div>
                  </div>
                </div>
              </div>
      
              <!-- <div class="field-group" [class.active]="panelState.securityBondActive" *ngIf="paymentSummary.guaranteePolicy.bondAmountNumberWeeks && paymentSummary.bondAmount">
              <div class="field-row font-medium">
                <div class="field-label whitespace-nowrap">{{'booking.bond' | translate}}  ({{paymentSummary.guaranteePolicy.bondAmountNumberWeeks}} x {{'rent-types.week' | translate}})
                  <span [pTooltip]="tooltipBond" tabIndex="0" tooltipPosition="bottom" [tooltipEvent]="tooltipEvent" *ngIf="getDescription(paymentConfigInfo.bondToolTip)"
                  class="material-symbols-outlined text-[16px] mt-[-4px] cursor-pointer text-accent">
                  help
                </span>
                <ng-template #tooltipBond>
                  <div [innerHtml]="getDescription(paymentConfigInfo.bondToolTip)"></div>
                </ng-template>
                </div>
                <div class="field-value whitespace-nowrap">{{formatNumber(paymentSummary.bondAmount) | money}}</div>
        
                <div class="field-expand">
                  <span class="field-expand-icon cursor-pointer"
                    (click)="panelState.securityBondActive = !panelState.securityBondActive"><img
                      src="assets/images/down.svg" style="filter: invert(1) !important" alt=""></span>
                </div>
              </div>
              <div class="field-content">
                <div class="field-row text-white">
                  <div class="field-label font-normal">{{'booking.bond' | translate}}  ({{paymentSummary.guaranteePolicy.bondAmountNumberWeeks}} x {{'rent-types.week' | translate}})</div>
                  <div class="field-value font-normal"></div>
                </div>
              </div>
            </div> -->
      
      
              <!-- holding fee rent -->
              <div class="field-group" [class.active]="panelState.holdingFeeActive"
                *ngIf="paymentSummary.guaranteePolicy.holdingFeeNumberMonths && paymentSummary.hodingFeeAmount">
                <div class="field-row">
                  <div class="field-label whitespace-nowrap">{{'booking.holding' | translate}}
                    ({{paymentSummary.guaranteePolicy.holdingFeeNumberMonths}} x {{'rent-types.month' | translate}})
                    <span [pTooltip]="tooltipHolding" tabIndex="0" tooltipPosition="bottom" [tooltipEvent]="tooltipEvent"
                      *ngIf="getDescription(paymentConfigInfo.holdingFeeToolTip)"
                      class="material-symbols-outlined text-[16px] mt-[-4px] cursor-pointer text-accent">
                      help
                    </span>
                    <ng-template #tooltipHolding>
                      <div [innerHtml]="getDescription(paymentConfigInfo.holdingFeeToolTip)"></div>
                    </ng-template>
                  </div>
                  <div class="field-value whitespace-nowrap">{{formatNumber(paymentSummary.hodingFeeAmount) | money}}</div>
      
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer"
                      (click)="panelState.holdingFeeActive = !panelState.holdingFeeActive"><img src="assets/images/down.svg"
                        style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
                <div class="field-content">
                  <div class="field-row text-white">
                    <div class="field-label font-normal">{{'booking.holding' | translate}}
                      ({{paymentSummary.guaranteePolicy.holdingFeeNumberMonths}} x {{'rent-types.month' | translate}})</div>
                    <div class="field-value font-normal"></div>
                  </div>
                </div>
              </div>
      
              <div class="field-group" [class.active]="panelState.holdingFeeActive"
                *ngIf="paymentSummary.guaranteePolicy.holdingFeeNumberWeeks && paymentSummary.hodingFeeAmount">
                <div class="field-row">
                  <div class="field-label whitespace-nowrap">{{'booking.holding' | translate}}
                    ({{paymentSummary.guaranteePolicy.holdingFeeNumberWeeks}} x {{'rent-types.week' | translate}})
                    <span [pTooltip]="tooltipHolding" tabIndex="0" tooltipPosition="bottom" [tooltipEvent]="tooltipEvent"
                      *ngIf="getDescription(paymentConfigInfo.holdingFeeToolTip)"
                      class="material-symbols-outlined text-[16px] mt-[-4px] cursor-pointer text-accent">
                      help
                    </span>
                    <ng-template #tooltipHolding>
                      <div [innerHtml]="getDescription(paymentConfigInfo.holdingFeeToolTip)"></div>
                    </ng-template>
                  </div>
                  <div class="field-value whitespace-nowrap">{{formatNumber(paymentSummary.hodingFeeAmount) | money}}</div>
      
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer"
                      (click)="panelState.holdingFeeActive = !panelState.holdingFeeActive"><img src="assets/images/down.svg"
                        style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
                <div class="field-content">
                  <div class="field-row text-white">
                    <div class="field-label font-normal">{{'booking.holding' | translate}}
                      ({{paymentSummary.guaranteePolicy.holdingFeeNumberWeeks}} x {{'rent-types.week' | translate}})</div>
                    <div class="field-value font-normal"></div>
                  </div>
                </div>
              </div>
      
              <!-- advance rent -->
              <div class="field-group" [class.active]="panelState.advanceRentActive">
                <div class="field-row">
                  <div class="field-label"
                    *ngIf="!paymentSummary.guaranteePolicy.advanceRentNumberMonths && !paymentSummary.guaranteePolicy.advanceRentNumberWeeks">
                    {{'booking.first-months-rent' | translate}}
                    <span [pTooltip]="tooltipAdvRent" tabIndex="0" tooltipPosition="bottom" [tooltipEvent]="tooltipEvent"
                      *ngIf="getDescription(paymentConfigInfo.advRentToolTip)"
                      class="material-symbols-outlined text-[16px] mt-[-4px] cursor-pointer text-accent">
                      help
                    </span>
                    <ng-template #tooltipAdvRent>
                      <div [innerHtml]="getDescription(paymentConfigInfo.advRentToolTip)"></div>
                    </ng-template>
                  </div>
                  <div class="field-label" *ngIf="paymentSummary.guaranteePolicy.advanceRentNumberMonths">
                    {{'booking.first-months-rent' | translate}} - {{paymentSummary.guaranteePolicy.advanceRentNumberMonths}} month(s)
                    <span [pTooltip]="tooltipAdvRent" tabIndex="0" tooltipPosition="bottom" [tooltipEvent]="tooltipEvent"
                      *ngIf="getDescription(paymentConfigInfo.advRentToolTip)"
                      class="material-symbols-outlined text-[16px] mt-[-4px] cursor-pointer text-accent">
                      help
                    </span>
                    <ng-template #tooltipAdvRent>
                      <div [innerHtml]="getDescription(paymentConfigInfo.advRentToolTip)"></div>
                    </ng-template>
                  </div>
                  <div class="field-label" *ngIf="paymentSummary.guaranteePolicy.advanceRentNumberWeeks">
                    {{'booking.first-months-rent' | translate}} - {{paymentSummary.guaranteePolicy.advanceRentNumberWeeks}} week(s)
                    <span [pTooltip]="tooltipAdvRent" tabIndex="0" tooltipPosition="bottom" [tooltipEvent]="tooltipEvent"
                      *ngIf="getDescription(paymentConfigInfo.advRentToolTip)"
                      class="material-symbols-outlined text-[16px] mt-[-4px] cursor-pointer text-accent">
                      help
                    </span>
                    <ng-template #tooltipAdvRent>
                      <div [innerHtml]="getDescription(paymentConfigInfo.advRentToolTip)"></div>
                    </ng-template>
                  </div>
                  <div class="field-value">{{formatNumber(paymentSummary.firstMonthRent) | money}}</div>
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer"
                      (click)="panelState.advanceRentActive = !panelState.advanceRentActive"><img src="assets/images/down.svg"
                        style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
      
                <div class="field-content">
                  <div class="field-row text-white">
                    <div class="field-label font-normal">{{roomType.roomTypeName}} ({{ratePlan.ratePlanName}})</div>
                    <div class="field-value font-normal">{{formatNumber(paymentSummary.rateAmountOfFirstMonth) | money}}</div>
                  </div>
      
                  <div class="field-row text-white" *ngIf="paymentSummary.totalUtilitiesAmountOfFirstMonth">
                    <div class="field-label font-normal">{{'booking.utilities' | translate}} x 1</div>
                    <div class="field-value font-normal">{{formatNumber(paymentSummary.totalUtilitiesAmountOfFirstMonth) |
                      money}}</div>
                  </div>
      
                </div>
              </div>
      
              <div class="field-group" [class.active]="panelState.addOns"
                *ngIf="paymentSummary.totalAddonsAmountOfTheFirstMonth">
                <div class="field-row">
                  <div class="field-label">{{'booking.extras' | translate}}</div>
      
                  <!-- <div class="field-value">{{paymentSummary.currency}} {{formatNumber(getTotalAdOnCost())}}</div> -->
                  <div class="field-value">{{formatNumber(paymentSummary.totalAddonsAmountOfTheFirstMonth) | money}}</div>
      
                  <div class="field-expand">
                    <span class="field-expand-icon cursor-pointer" (click)="panelState.addOns = !panelState.addOns"><img
                        src="assets/images/down.svg" style="filter: invert(1) !important" alt=""></span>
                  </div>
                </div>
      
                <div class="field-content">
                  <!-- extra configuration -->
                  <div class="field-row text-white" *ngFor="let extra of paymentSummary.addOns">
                    <div class="field-label font-normal">{{extra.extraName}} x {{extra.quantity}} <span *ngIf="getTaxDes(extra)">({{getTaxDes(extra)}})</span></div>
                    <div class="field-value font-normal">{{formatNumber(extra.totalAmount) | money}}</div>
                    <div class="field-value"></div>
                  </div>
                </div>
              </div>
      
              <div class="field-group mt-[3px] lg:mt-0">
                <div class="field-row">
                  <div class="field-label uppercase font-medium text-[16px]">{{'booking.total' | translate}}</div>
                  <div class="field-value font-medium text-[16px]">
                    {{formatNumber(paymentSummary.initialPaymentAmountOfFirstMonth) | currency: paymentSummary.currency :
                    'symbol-narrow'}}</div>
                </div>
              </div>
      
            </div>
      
            <div class="line" *ngIf="canShowBondInfo()"></div>
            <!-- Bond info payment -->
            <div class="summary-block-title" *ngIf="canShowBondInfo()">{{'payment.bond.info-payments' | translate}}</div>
            <div *ngIf="canShowBondInfo()" class="mt-2 mb-4 text-white" translate="payment.bond.info-payments-desc"
              [translateParams]="{'currencyCode': paymentSummary?.currency}"></div>
            <div *ngIf="canShowBondInfo()" class="field-group" [class.active]="panelState.bondInfoPayment">
              <div class="field-row">
                <div class="field-label">{{'payment.bond' | translate}}</div>
                <div class="field-value">{{formatNumber(paymentSummary?.guaranteePolicy?.bondAmount || 0) | money}}</div>
      
                <div class="field-expand">
                  <span class="field-expand-icon cursor-pointer"
                    (click)="panelState.bondInfoPayment = !panelState.bondInfoPayment"><img src="assets/images/down.svg"
                      style="filter: invert(1) !important" alt=""></span>
                </div>
              </div>
      
              <div class="field-content">
                <div class="field-row text-white">
                  <div class="field-label font-normal">{{'payment.bond' | translate}}</div>
                  <div class="field-value font-normal">{{formatNumber(paymentSummary?.guaranteePolicy?.bondAmount || 0) |
                    money}}</div>
                </div>
      
              </div>
            </div>
      
            <!-- discount codes -->
            <div class="line mt-5 mb-5" *ngIf="discounts && discounts.length"></div>
            <div class="field-group" *ngIf="discounts && discounts.length" [class.active]="panelState.discountCode">
              <div class="field-row">
                <div class="field-label">{{ 'booking.applicable-discounts' | translate}}</div>
                <div class="field-value">{{discounts.length}} {{'booking.applied' | translate}}</div>
      
                <div class="field-expand">
                  <span class="field-expand-icon cursor-pointer"
                    (click)="panelState.discountCode = !panelState.discountCode"><img src="assets/images/down.svg"
                      style="filter: invert(1) !important" alt=""></span>
                </div>
              </div>
      
              <div class="field-content text-white">
                <div class="field-row" *ngFor="let discount of discounts">
                  <div class="field-label font-normal">{{discount.accessCode}}</div>
                  <div class="field-value font-normal">{{discount.description || discount.name}}</div>
                </div>
              </div>
            </div>
      
            <div>
              <button *ngIf="!atExtraPage" (click)="submit()" class="hidden lg:flex btn btn-primary w-full"
                [disabled]="!roomType || !room">{{'button.label.confirm' | translate}}</button>
              <button *ngIf="atExtraPage" (click)="submit()" class="hidden lg:flex btn btn-primary w-full"
                [disabled]="!roomType || !room">{{'button.label.apply-now' | translate}}</button>
            </div>
            <div class="hidden lg:block text-center mt-2 text-gainsboro" *ngIf="!atExtraPage">
              Car parking and additional storage can be requested at the next step
            </div>
      
          </div>
      
        </div>
        <div class="h-[16px]">
        </div>
    </div>
  </div>
 </div>


